import React from 'react'

import { Steps } from 'antd'

import type { LntStepsProps } from './types'

export const LntSteps: React.FC<LntStepsProps> = props => {
  return <Steps { ...props } />
}
